import { inject, Injectable } from "@angular/core";
import { catchError, combineLatest, EMPTY, map, Observable } from "rxjs";
import { toFieldStringArray } from "../../../../common/utils/object-paths";
import { ApiService } from "../../../api/packbo/api.service";
import { createItemsNewsletterSubscriptions } from "../../../api/packbo/fn/items/create-items-newsletter-subscriptions";
import { readItemsCopyrightFooter } from "../../../api/packbo/fn/items/read-items-copyright-footer";
import { readItemsFooter } from "../../../api/packbo/fn/items/read-items-footer";
import { ItemsNewsletterSubscriptions } from "../../../api/packbo/models/items-newsletter-subscriptions";
import { FooterStore } from "./footer.store";

@Injectable()
export class FooterService {
    private readonly store = inject(FooterStore);
    private readonly apiService = inject(ApiService);

    public loadFooterContent(): Observable<void> {
        const footerFields = toFieldStringArray({
            translations_refs: {
                languages_code: null,
                newsletter_title: null
            },
            navigation_items_refs: {
                navigation_items_id: {
                    id: null,
                    type: null,
                    page_ref: {
                        translations_refs: {
                            languages_code: null,
                            slug: null
                        }
                    },
                    translations_refs: {
                        languages_code: null,
                        title: null
                    }
                }
            },
            social_links_refs: {
                social_links_id: {
                    id: null,
                    icon: null,
                    url: null
                }
            }
        });

        const copyrightFields = toFieldStringArray({
            translations_refs: {
                languages_code: null,
                copyright: null
            },
            navigation_items_refs: {
                navigation_items_id: {
                    id: null,
                    page_ref: {
                        translations_refs: {
                            languages_code: null,
                            slug: null
                        }
                    },
                    translations_refs: {
                        languages_code: null,
                        title: null
                    }
                }
            }
        });

        const footerItemObs = this.apiService.invoke(readItemsFooter, { fields: footerFields }).pipe(
            map((footerItem) => {
                this.store.setFooterDefinition(footerItem.data ?? null);
            }),
            catchError(() => EMPTY)
        );

        const copyrightItemObs = this.apiService.invoke(readItemsCopyrightFooter, { fields: copyrightFields }).pipe(
            map((copyrightItems) => {
                this.store.setCopyrightDefinition(copyrightItems.data ?? null);
            }),
            catchError(() => EMPTY)
        );

        return combineLatest([footerItemObs, copyrightItemObs]).pipe(
            map(() => {
                return;
            })
        );
    }

    public setSubmitMessage(submitMessage: string | null): void {
        this.store.setSubmitMessage(submitMessage);
    }

    public createNewsletterSubscription(email: string): Observable<void> {
        const subscription: ItemsNewsletterSubscriptions = {
            email: email
        };

        return this.apiService.invoke(createItemsNewsletterSubscriptions, { body: subscription }).pipe(
            map(() => {
                return;
            })
        );
    }
}
